export interface GlobalDataOverrides {
  festivalTitle: string;
  festivalSubtitle: string;
  royalMotto: string;
  festivalTheme?: string;
  heroGreeting: string;
  secretariatEmail: string;
  activeWhatsapp: string;
  totalVillagesLabel: string;
  customBanners: { [key: string]: string };
  lastUpdatedBy: string;
  lastUpdatedAt: string;
}

const OVERRIDES_KEY = 'uzairue_global_data_overrides_v1';
export const OVERRIDES_CHANGE_EVENT = 'uzairue_overrides_updated';

export const INITIAL_OVERRIDES: GlobalDataOverrides = {
  festivalTitle: 'ERUE FESTIVAL 2026',
  festivalSubtitle: 'The Sacred Heritage & Cultural Celebration of Uzairue Kingdom',
  royalMotto: 'One People, One Kingdom, One Destiny',
  festivalTheme: 'Uzairue Heritage: Culture, Security, Prosperity',
  heroGreeting: 'Welcome to the Official Uzairue Kingdom & ERUE Festival Portal',
  secretariatEmail: 'erueuzairue@gmail.com',
  activeWhatsapp: '+2348059079068',
  totalVillagesLabel: '22 Villages & Component Communities',
  customBanners: {},
  lastUpdatedBy: 'Ikpemhi Oshioke',
  lastUpdatedAt: new Date().toISOString(),
};

export function getGlobalOverrides(): GlobalDataOverrides {
  try {
    const raw = localStorage.getItem(OVERRIDES_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      return { ...INITIAL_OVERRIDES, ...parsed };
    }
  } catch (err) {
    console.error('Failed to load global overrides:', err);
  }
  return INITIAL_OVERRIDES;
}

export function saveGlobalOverrides(overrides: Partial<GlobalDataOverrides>, updatedBy = 'Ikpemhi Oshioke'): GlobalDataOverrides {
  try {
    const current = getGlobalOverrides();
    const updated: GlobalDataOverrides = {
      ...current,
      ...overrides,
      lastUpdatedBy: updatedBy,
      lastUpdatedAt: new Date().toISOString(),
    };
    localStorage.setItem(OVERRIDES_KEY, JSON.stringify(updated));
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(OVERRIDES_CHANGE_EVENT, { detail: updated }));
    }
    // Also sync to backend if online
    fetch('/api/portal/overrides', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updated),
    }).catch(() => {});

    return updated;
  } catch (err) {
    console.error('Failed to save global overrides:', err);
    return getGlobalOverrides();
  }
}
